interface NetworkPunchOutCatDTO {
    id: number;
    companyCode: string;
    purchaseOrg: string;
    supplier: string;
    ociUserName: string;
    password: string;
    cxmlFromDomain:string;
    cxmlFromId: string;
    cxmlToDomain:string;
    cxmlToID: string;
    senderDomain: string;
    senderId: string;
    url: string;
    protocol: string;
    userEmail: string;
    timeStamp: string;
}

// sample response as below.

// [
//     {
//         "id": 9,
//         "companyCode": "DE21",
//         "purchaseOrg": "DE10",
//         "supplier": "100398245",
//         "ociUserName": "",
//         "password": "bnIzNDV0ejE=",
//         "cxmlFromId": "AN01001441040-T",
//         "cxmlToID": "AN01000321571-T",
//         "url": "https://service.lsl.de/entrypoint/ariba/lsl",
//         "protocol": "cXML",
//         "userEmail": "",
//         "timeStamp": "1900-01-01T00:00:00"
//     }
// ]

export class PunchOutCatDetails {
    constructor(
       public id: number,
       public companyCode: string,
       public purchaseOrg: string,
       public supplier: string,
       public ociUserName: string,
       public password: string,
       public cxmlFromDomain: string,
       public cxmlFromId: string,
       public cxmlToDomain: string,
       public cxmlToID: string,
       public senderDomain: string,
       public senderId: string,
       public url: string,
       public protocol: string,
       public userEmail: string,
       public timeStamp: string
    ) {
    }

    static FromBackend(data: NetworkPunchOutCatDTO): PunchOutCatDetails {
        return new PunchOutCatDetails(
            data.id,
            data.companyCode,
            data.purchaseOrg,
            data.supplier,
            data.ociUserName,
            data.password,
            data.cxmlFromDomain,
            data.cxmlFromId,
            data.cxmlToDomain,
            data.cxmlToID,
            data.senderDomain,
            data.senderId,
            data.url,
            data.protocol,
            data.userEmail,
            data.timeStamp,
        )
    }
}
